export default "__VITE_PUBLIC_ASSET__bac358d8__"